// Domain-neutral grey placeholder. Callers that need a domain-specific
// fallback (property image, avatar, etc.) build their own handler via
// `makeImgErrorHandler(<their placeholder>)`.
const NEUTRAL_FALLBACK = 'https://placehold.co/800x500/e9eaeb/717680'

const swap = (e: Event, fallback: string) => {
  const img = e.currentTarget as HTMLImageElement
  if (img.src !== fallback) {
    img.src = fallback
  }
}

export const onImgError = (e: Event) => swap(e, NEUTRAL_FALLBACK)

export const makeImgErrorHandler = (fallback: string) => (e: Event) => swap(e, fallback)
